module.exports = __webpack_public_path__ + "img/暂无数据.88aca572.png";